<template>
  <loader v-if="loading"/>
  <welcome v-else :show-discount-welcome-image="showDiscountWelcomeImage"
           :referralData="referralData"/>
</template>

<script>
import _ from 'lodash';
import Loader from '@/base-components/Loader';
import { mapActions } from 'vuex';
import Welcome from '@/pages/responsive-pages/non-authenticated/wine-and-dine/Welcome';
import Segment from '../../../../Segment';
import config from '../../../../config';

export default {
  name: 'WineAndDineFlow',
  components: {
    Welcome,
    Loader,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    referralData: {
      type: Object,
    },
  },
  async created() {
    this.loading = true;
    this.loading = false;
    const utmParams = _.pickBy(this.$route.query, (v, k) => k.startsWith('utm_'));
    Segment.trackUserGot('SignupEntered', { ...utmParams });
    Segment.trackUserGotToPixel('SE');
    this.setUtmParams(utmParams);
    this.saveReferrer(utmParams);
  },
  computed: {
    showDiscountWelcomeImage() {
      return this.$route.query.utm_source === 'Discount_app';
    },
  },
  methods: {
    ...mapActions('signup', ['setUtmParams']),
    saveReferrer(utmParams) {
      if (utmParams.utm_term) {
        localStorage.setItem('riseup.utm_referrer_eoy', utmParams.utm_term);
      }
      if (this.referralData) {
        const { cookieDomain } = config.get();
        this.$cookies.set('referralToken', this.referralData.referralToken, '30d', '/', cookieDomain, true, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .welcome {
    @include white-page-frame;
    height: 100%;

    .image-container {
      width: 100%;
    }

    .page-content {
      @include responsive-padding;
      margin-top: 30px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .description {
        .title {
          font-size: 22px;
          line-height: 1.27;
          width: 100%;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .subtitle {
          font-size: 18px;
          line-height: 1.5;

          .bold {
            font-weight: bold;
          }
        }
      }

      .button-container {
        @include responsive-padding-top-bottom;

        .button-to-signup {
          width: 100%;
          white-space: nowrap;
        }
      }

      .already-registered {
        margin-bottom: 30px;
        color: $riseup_light_blue;
        text-align: center;

        .enter {
          font-weight: bold;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

</style>
